import { ComponentType, useEffect, useRef } from 'react';
import { ImageProps } from '../../Image';
import { SlideAnimator } from '../../SlideAnimator';
import {
    ImageListContainerElement,
    ListImageElement,
    ThumbnailButtonElement,
    ThumbnailButtonElementWrapper,
} from './style';
import { ImageListProps } from './types';

interface ImageListFactory {
    Image?: ComponentType<ImageProps>;
}

export const imageListFactory =
    ({ Image = ListImageElement }: ImageListFactory = {}) =>
    ({ images, currentId, onSelectedImageChange }: ImageListProps) => {
        const activeItemRef = useRef<HTMLButtonElement & HTMLDivElement>(null);

        useEffect(() => {
            if (activeItemRef.current) {
                activeItemRef.current.focus();
            }
        }, [currentId, activeItemRef]);

        const handleClick = (clickedImageId: string) => () => {
            if (onSelectedImageChange) {
                onSelectedImageChange(clickedImageId);
            }
        };

        return (
            <ImageListContainerElement data-test-image-list>
                <SlideAnimator selectedChildId={currentId}>
                    {images.map(({ id, ...other }) => (
                        <ThumbnailButtonElementWrapper key={id}>
                            <ThumbnailButtonElement
                                id={id}
                                selected={id === currentId}
                                onClick={handleClick(id)}
                                data-test-thumbnail={id}
                                ref={id === currentId ? activeItemRef : null}
                            >
                                <Image draggable={false} id={id} {...other} />
                            </ThumbnailButtonElement>
                        </ThumbnailButtonElementWrapper>
                    ))}
                </SlideAnimator>
            </ImageListContainerElement>
        );
    };
export default imageListFactory();
